import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import store from './vuex';
import Antd from 'ant-design-vue';
import VCharts from 'v-charts'
import api from "./apis";
import 'ant-design-vue/dist/antd.less';

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VCharts)
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.seoTitle || to.meta.title
  const token = window.sessionStorage.getItem('token');
  const paths = ['/login', '/install', '/401'];
  if (!token && paths.indexOf(to.path) === -1) {
    next({
      path: '/login',
      query: {
        redirect: to.path
      }
    });
    return
  }
  if (token) {
    try {
      const corpId = window.sessionStorage.getItem('corpid');
      if (!corpId) {
        const data = await api.postConfigSDK({ url: window.location.href.split('#')[0] })
        if (data.code === 1000) this.$store.commit('code', data.code);
        window.wx.agentConfig({
          debug: true,
          corpid: data.corpId,
          agentid: data.agentId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ['selectExternalContact'],
          success: function () { next(); },
          fail: function (res) {
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        })
        window.sessionStorage.setItem('corpid', data.corpId);
      }
    } catch (err) {
      console.log(err);
    }
  }
  next();
});

new Vue({
  router,
  axios,
  store,
  render: h => h(App)
}).$mount('#app')
